// Utility functions for Lenis smooth scrolling

// Scroll to top
export const scrollToTop = () => {
  if (window.lenis) {
    window.lenis.scrollTo(0, {
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
    });
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

// Scroll to element by ID
export const scrollToElement = (elementId, offset = 0) => {
  const element = document.getElementById(elementId);
  if (element && window.lenis) {
    window.lenis.scrollTo(element, {
      offset: offset,
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
    });
  } else if (element) {
    const elementPosition = element.offsetTop - offset;
    window.scrollTo({ top: elementPosition, behavior: 'smooth' });
  }
};

// Scroll to element by selector
export const scrollToSelector = (selector, offset = 0) => {
  const element = document.querySelector(selector);
  if (element && window.lenis) {
    window.lenis.scrollTo(element, {
      offset: offset,
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
    });
  } else if (element) {
    const elementPosition = element.offsetTop - offset;
    window.scrollTo({ top: elementPosition, behavior: 'smooth' });
  }
};

// Scroll by a specific amount
export const scrollBy = (amount) => {
  if (window.lenis) {
    const currentScroll = window.lenis.scroll;
    window.lenis.scrollTo(currentScroll + amount, {
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
    });
  } else {
    window.scrollBy({ top: amount, behavior: 'smooth' });
  }
};

// Get current scroll position
export const getCurrentScroll = () => {
  if (window.lenis) {
    return window.lenis.scroll;
  }
  return window.pageYOffset || document.documentElement.scrollTop;
};

// Stop scrolling
export const stopScrolling = () => {
  if (window.lenis) {
    window.lenis.stop();
  }
};

// Start scrolling (resume)
export const startScrolling = () => {
  if (window.lenis) {
    window.lenis.start();
  }
};
